import { useEffect, useState } from "react";
import { announcements, type Announcement } from "../api/client";
import { useCurrentUser } from "../lib/auth";

const DISMISS_KEY = "logbuch-announcement-dismissed";

/**
 * App-weites Admin-Broadcast-Banner ("Update 0.0.51 in Arbeit — Rollout
 * folgt"). Lädt das neueste aktive Announcement, dismissbar pro ID — eine
 * neue Ankündigung erscheint wieder, die weggeklickte bleibt weg.
 */
export default function AnnouncementBanner() {
  const user = useCurrentUser();
  const [ann, setAnn] = useState<Announcement | null>(null);
  const [dismissed, setDismissed] = useState<number | null>(() => {
    try {
      const v = localStorage.getItem(DISMISS_KEY);
      return v ? Number(v) : null;
    } catch {
      return null;
    }
  });

  useEffect(() => {
    if (!user) return;
    announcements
      .active()
      .then((a) => setAnn(a))
      .catch(() => setAnn(null));
  }, [user?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!ann || ann.id === dismissed) return null;

  const warn = ann.level === "warn";
  return (
    <div
      className={
        "fixed top-0 inset-x-0 z-[60] px-3 py-2 text-sm flex items-start gap-2 shadow-lg " +
        (warn
          ? "bg-amber-600 text-amber-50"
          : "bg-brand-600 text-brand-50")
      }
      style={{ paddingTop: "max(env(safe-area-inset-top), 0.5rem)" }}
      role="status"
    >
      <span className="shrink-0">{warn ? "⚠" : "📣"}</span>
      <span className="flex-1 leading-snug">{ann.message}</span>
      <button
        type="button"
        onClick={() => {
          try {
            localStorage.setItem(DISMISS_KEY, String(ann.id));
          } catch {}
          setDismissed(ann.id);
        }}
        className="shrink-0 rounded px-1.5 opacity-80 hover:opacity-100"
        aria-label="Ankündigung schließen"
      >
        ✕
      </button>
    </div>
  );
}
